import accountApi from "@/apis/AccountAPI";
import commonFn from "@/commons/commonFunction";
import axios from "axios";
import httpClient from "@/apis/base/axios-httpclient";
// import { removeStorage } from '../stores/vuex-persistance-plugin';
import { UserManager, WebStorageStateStore, User } from "oidc-client";
import { ProviderType } from "@/constants";

export default {
  /**
   * Lấy lại token
   * @param {} context
   * @param {*} payload
   */
  async getToken(context, payload) {
    //request
    let url = [window._apis.Auth, "/connect/token"].join(""),
      refreshToken = context.state.refreshToken;
    if (!refreshToken) {
      refreshToken = commonFn.getLocalStorage("refreshToken");
    }
    let param = {
      grant_type: "refresh_token",
      client_id: "authservice-api-client",
      refresh_token: refreshToken,
    };
    const params = new URLSearchParams();
    params.append("grant_type", "refresh_token");
    params.append("client_id", "authservice-api-client");
    params.append("refresh_token", refreshToken);
    const config = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    };
    let res = await axios.post(url, params, config);
    if (res && res.data) {
      let tokenParams = {
        expiresIn: res.data.expires_in,
        accessToken: res.data.access_token,
        refreshToken: res.data.refresh_token,
      };
      context.commit("updateToken", tokenParams);
    }
    return res;
  },

  /**
   * Hàm lấy token và sinh token mới cho web UI
   * @param {Object} payload - Context
   * @param {Object} param - Tham số
   * @param {string} param.code - Authorization code
   * @param {string} param.code_verifier - Code verifier
   * @param {string} param.idType - Loại ID xác thực (JETPAYID hoặc MISAID)
   */
  async GetTokenJetPayId(payload, param) {
    const me = this;

    let url = [window._apis.Auth, "/api/account/token"].join("");
    var params = {
      code: param.code,
      codeVerifier: param.code_verifier,
    };

    // Thêm provider nếu idType là JetPay ID
    if (param.idType === ProviderType.AUTH_JETPAY_ID) {
      params.provider = ProviderType.AUTH_JETPAY_ID;
    }

    // Build tham số
    let request = {
      url: url,
      params,
    };
    var res = await httpClient.postAsync(request);
    //var res = await axios.post(url, params, header);
    return res;
  },

  /**
   * Đăng nhập
   * @param {Đăng nhập} context
   * @param {*} payload
   */
  async login(context, payload) {
    //request
    let url = [window._apis.Auth, "/api/account/login"].join("");
    let param = {
      AccessToken: payload,
    };
    // Build tham số
    let request = {
      url: url,
      data: param,
    };
    // Call api
    var res = await httpClient.postAsync(request, true);
    if (res && res.accessToken) {
      //localStorage.clear();
      context.commit("updateToken", res);
    }
    return res;
  },

  /**
   * Hàm cập nhật token
   */
  updateToken(context, payload) {
    if (payload) {
      context.commit("updateToken", payload);
    }
  },

  /**
   * Lấy config cho xác thực
   * @param {Object} context - Context Vuex
   * @param {Object} payload - Các tham số truyền vào
   * @param {string} payload.idType - Loại ID xác thực (JETPAYID hoặc MISAID)
   */
  async getConfig(context, payload) {
    // let url = [window._apis.Auth, "/api/account/config"].join("");
    // // Build tham số
    // let request = {
    //   url: url,
    // };
    // // Call api
    // let res = await httpClient.getAsync(request);
    // return res;
    return await commonFn.getAuthConfig(payload?.idType);
  },
  /**
   * Đăng nhập version 2
   * @param {Object} context - Context Vuex
   * @param {Object} param - Tham số
   * @param {string} param.code - Authorization code
   * @param {string} param.code_verifier - Code verifier
   * @param {string} param.returnUrl - Redirect URL sau đăng nhập
   * @param {string} param.idType - Loại ID xác thực (JETPAYID hoặc MISAID)
   */
  async loginv2(context, param) {
    const me = this;

    let url = [window._apis.Auth, "/api/account/loginv2"].join("");
    var params = {
      code: param.code,
      codeVerifier: param.code_verifier,
      returnUrl: param.returnUrl,
    };

    // Thêm provider nếu idType là MISA ID
    if (param.idType === ProviderType.AUTH_MISA_ID) {
      params.provider = ProviderType.AUTH_MISA_ID;
    }

    // Build tham số
    let request = {
      url: url,
      params,
    };
    var res = await httpClient.getAsync(request);
    return res;
  },
  /**
   * Hàm check tài khoản đã xác thực chưa
   */
  async checkAccountVerification(payload, param) {
    let url = [window._apis.Auth, "/api/account/verification"].join("");
    var params = {
      userName: param.userName,
    };
    // Build tham số
    let request = {
      url: url,
      params,
    };
    var res = await httpClient.postAsync(request);
    return res;
  },

  async updateUserActive(context, payload) {
    let url = [window._apis.Auth, "/api/account/user-active?id=", payload.id].join("");
    let param = {
      scope: payload.scope,
    };
    // Build tham số
    let request = {
      url: url,
      data: payload.scope,
    };
    // Call api
    var res = await httpClient.postAsync(request, true);
    if (res && res.accessToken) {
      //localStorage.clear();
      context.commit("updateToken", res);
    }
    return res;
  },

  /**
   * Đăng xuất
   */
  async logoff() {
    const me = this;

    let url = [window._apis.Auth, "/api/account/logout"].join("");
    let res = await httpClient.getAsync({ url: url });
    if (!res || !res.success) {
      return console.error(res, "Logout error");
    }
    const loginProvider = localStorage.getItem("loginProvider") || ProviderType.AUTH_MISA_ID;

    const config = await commonFn.getAuthConfig(loginProvider);
    if (config) {
      window.location.href = `${config.authority}Account/LogOut?postLogoutRedirectUri=${config.redirect_uri}/login&clientId=${config.client_id}`;
    }
    localStorage.clear();
  },

  /**
   * remove token
   */
  removeToken(context) {
    //remove token
    context.commit("removeToken");
  },
  /*
   * Lấy trạng thái collapse của left menu
   */
  getLeftMenuCollapse(context, payload) {
    context.commit("updateLeftMenuCollapse", payload);
  },

  /**
   * Đánh dấu đã hoàn thành getting
   */
  completeGetting(context) {
    context.commit("completeGetting");
  },
};
